"use client";
import SlimBand from "../_components/pageSpecific/slimBand";
import BackgroundHero from "../_components/section/hero/backgroundHero";
import bgImage from "public/images/contact/Group-Picture-Transparent-v2.png";
import heartImg from "public/images/hearts/half-heart-with-tag-line.png";
import { GROUP_LINKS, SOCIAL_LIST, ENQUIRIES_LIST } from "~/content/contact";
import ContactSlider from "../_components/pageSpecific/contact/contactSlider";
import ContactFormSection from "../_components/pageSpecific/contact/contactFormSection";
import BookDiscovery from "../_components/pageSpecific/contact/book";
import { useRef, useEffect } from "react";
import { useSearchParams } from "next/navigation";
import scrollToSection from "../_components/common/scrollToSection";
import { CONTACT_SECTION_CONSTANTS } from "../contact-us/CONTACT_SECTION_CONSTANTS";

const ContactPageLayout = () => {
  const contactFormRef = useRef<HTMLDivElement | null>(null);
  const contactBookRef = useRef<HTMLDivElement | null>(null);

  const searchParams = useSearchParams();
  const params = searchParams.get("state");
  const state: string | undefined = params as string | undefined;

  useEffect(() => {
    const refs = [
      { title: CONTACT_SECTION_CONSTANTS.FORM, ref: contactFormRef },
      { title: CONTACT_SECTION_CONSTANTS.BOOK, ref: contactBookRef },
    ];
    if (state) {
      scrollToSection(state, refs);
    }
  }, [state]);

  return (
    <>
      <BackgroundHero
        title="We'd love to help"
        body={
          <>
            <p>
              Whether you’re a participant, prospective participants, parents,
              guardians or just in need of some advice, we’d love to hear from
              you.
            </p>
            <p className="mt-4">
              Once you get in touch, we’ll match your enquiry with the most
              appropriate team member and have them contact you to chat about
              your needs.
            </p>
          </>
        }
        bodyWidth="w-[14.5rem] xs:w-[23rem] md:w-[28rem]"
        right
        custom
        image={heartImg}
        imageClass="lg:-left-24 2xl:-left-36"
        bgImage={bgImage}
        bgImageClass="top-0 -left-16 -right-28 mx-auto max-w-[31rem] xs:max-w-none xs:right-0 xs:-left-36 xs:h-full sm:-left-36 md:right-0 md:-left-56 md:w-auto xl:-left-[20rem] "
        bgImageFit="auto"
        actionGroup={
          <>
            <div className="mt-8 hidden h-full justify-end gap-4 lg:flex">
              <GROUP_LINKS
                items={ENQUIRIES_LIST}
                title="Enquiries"
                borderColour="border-orange"
              />
              <GROUP_LINKS
                items={SOCIAL_LIST}
                title="Socials"
                borderColour="border-green"
                newTab
              />
            </div>
            <ContactSlider />
          </>
        }
        maxWidth="max-w-7xl"
      />
      <SlimBand />
      <ContactFormSection ref={contactFormRef} />
      <BookDiscovery ref={contactBookRef} />
    </>
  );
};

export default ContactPageLayout;
